export const MAX_BUDGET = 100000;
export const OPPORTUNITY_YEAR = 2026;
export const LIMITED_OPPORTUNITY_COUNT = 1;

export const COOP_OPPORTUNITY_SALESKIT_LINK = "/userfiles/FY27_Co-Op_Sales_Kit_6-29-26_r3.pdf";

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
export const FACEBOOK_APP_ID = '274101851064397';

export const OPPORTUNITY_RESULTS_PER_PAGE = 10;